<ng-container *ngIf="showResponse && response">
  <div class="icon-container">
    <div class="d-flex justify-content-end mb-1">
      <div class="toolbar py-1 px-3 float-right">
        <!-- <img src="./assets/img/play_icon.svg" title="Play" class="cursor-pointer" /> -->
        <img src="./assets/img/copy_icon.svg" title="Copy to clipboard" (click)="copyToClipboard()"
          class="ml-3 cursor-pointer" />
        <div class="menu-btn ml-3 d-inline-block" [matMenuTriggerFor]="menu" #t="matMenuTrigger">
          <img src="./assets/img/download_icon.svg" title="Download as" />
          <span type='button' class="text-primary mx-2">Download</span>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="exportAsPdf()"><img src="./assets/img/pdf_icon.svg" title="Download as PDF"
                class="mr-3" />Download as PDF</button>
            <button mat-menu-item [disabled]="true" matTooltip="Coming soon"><img
                src="./assets/img/open_disabled_icon.svg" title="Open in Slides" class="mr-3" />Open in Google
              Slides</button>
          </mat-menu>
          <img src="./assets/img/down_arrow.svg" title="Download as" />
        </div>
      </div>
    </div>
  </div>

  <div id="downloadableContent" class="card p-3">
    <div [innerHTML]="insightsResponse" *ngIf="insightsResponse" id="insights"></div>
    <div class="canvas-div mt-4">
      <canvas id="chart-generator" [style]="getStyle(t.menuOpen)"></canvas>
    </div>
  </div>

  <div class="error" *ngIf="showError && !showResponse">Unfortunately, we are unable to generate the visualization for
    your data. </div>
</ng-container>

<!-- <div [innerHTML]="safeHtml | safe:'html'" runScripts></div> -->